export default __webpack_public_path__ + "static/media/mediapipe.af263ee1.png";